import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { User } from '@/lib/index';

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<void>;
  register: (name: string, email: string, password: string) => Promise<void>;
  logout: () => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      user: null as User | null,
      isAuthenticated: false,

      login: async (email: string, password: string) => {
        await new Promise((resolve) => setTimeout(resolve, 500));

        const mockUser: User = {
          id: '1',
          name: email.split('@')[0],
          email,
          role: email.includes('admin') ? 'admin' : 'customer',
        };

        set({ user: mockUser, isAuthenticated: true });
      },

      register: async (name: string, email: string, _password: string) => {
        await new Promise((resolve) => setTimeout(resolve, 500));

        const mockUser: User = {
          id: Date.now().toString(),
          name,
          email,
          role: 'customer',
        };

        set({ user: mockUser, isAuthenticated: true });
      },

      logout: () => {
        set({ user: null, isAuthenticated: false });
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);
